export default {
    webhookLogsData: (state) => state.webhookLogsData,
    webhookLogFields: (state) => state.webhookLogFields,
    webhookLogModules: (state) => state.webhookLogModules,
    webhookLogActions: (state) => state.webhookLogActions,
    totalRecords: (state) => state.totalRecords,
}
